import React from "react";
import { Card, Typography } from "antd";

const ContactPage = () => (
  <div className="policy-container">
    <Card>
      <Typography.Title level={2}>Contact Us</Typography.Title>

      <Typography.Paragraph>
        <strong>Finllie Water</strong><br />
        No 44, 45, 46, Silicon Town Main Road Doddanagamangala, Electronic City Phase 2 Bengaluru Karnataka 560100 India<br /><br />

        <strong>Email:</strong> finlliesales@gmail.com<br />
        <strong>Phone:</strong> +91 9945089397<br /><br />

        Customer Support Hours: Monday–Friday: 9AM to 5PM IST
                                Saturday: 10AM to 4PM IST
      </Typography.Paragraph>
    </Card>
  </div>
);

export default ContactPage;
